// Keep in sync with the `/intranet` redirect in firebase.json (enforced by
// src/firebaseHosting.test.ts).
export const INTRANET_URL =
  "https://sites.google.com/unicamp.br/27-intranet/home";
